import api from '../utils/api';

/**
 * B-02 Vehicle Picker API — isolated from legacy VehicleContext /vehicles routes.
 */
export const vehiclePickerApi = {
  lookup: async (reg) => {
    const res = await api.get('/vehicles/lookup', { params: { reg } });
    return res.data?.data;
  },

  listMakes: async () => {
    const res = await api.get('/catalog/makes');
    return res.data?.data || [];
  },

  listModels: async (makeId) => {
    const res = await api.get('/catalog/models', { params: { make: makeId } });
    return res.data?.data || [];
  },

  listGenerations: async (modelId) => {
    const res = await api.get('/catalog/generations', { params: { model: modelId } });
    return res.data?.data || [];
  },

  listVariants: async (generationId) => {
    const res = await api.get('/catalog/variants', { params: { gen: generationId } });
    return res.data?.data || [];
  },

  getVehicles: async () => {
    const res = await api.get('/user/vehicles');
    return res.data?.data || [];
  },

  addVehicle: async (payload) => {
    const res = await api.post('/user/vehicles', payload);
    return res.data?.data;
  },

  setActive: async (vehicleId) => {
    const res = await api.patch(`/user/vehicles/${vehicleId}/active`);
    return res.data?.data;
  },

  deleteVehicle: async (vehicleId) => {
    await api.delete(`/user/vehicles/${vehicleId}`);
  },
};

export default vehiclePickerApi;
